interface ProfileQuoteProps {
  quote: string;
  author: string;
}

export default function ProfileQuote({ quote, author }: ProfileQuoteProps) {
  return (
    <div className="bg-[#E2F3FB] py-16">
      <div className="container mx-auto px-4 text-center max-w-4xl">
        <blockquote className="text-2xl md:text-3xl italic mb-4 serif-quote">
          “{quote}”
        </blockquote>

        <p className="text-lg font-medium">{author}</p>
      </div>
    </div>
  );
}
